import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.delivery_fee_group_setting.';
export const deliveryFeeGroupSettingGroupTableHeader = [
    {
        title: t(`${lc}group_setting_table.group_name`),
        align: 'start',
        sortable: true,
        value: 'name',
        width: 245,
    },
    {
        title: t(`${lc}group_setting_table.day_fee_count`),
        align: 'end',
        sortable: false,
        width: 146,
    },
    {
        title: t(`${lc}group_setting_table.worker_in_group`),
        align: 'center',
        sortable: false,
        width: 150,
    },
    {
        title: t(`${lc}group_setting_table.group_setting`),
        align: 'center',
        sortable: false,
        width: 130,
    },
];
export const deliveryFeeGroupSettingOptionTableHeader = [
    {
        title: t(`${lc}option_setting_table.from_amount`),
        align: 'end',
        sortable: false,
        width: 184,
    },
    {
        title: t(`${lc}option_setting_table.to_amount`),
        align: 'end',
        sortable: false,
        width: 184,
    },
    {
        title: t(`${lc}option_setting_table.fee`),
        align: 'end',
        sortable: false,
        width: 184,
    },
    {
        title: t(`${lc}option_setting_table.rate`),
        align: 'end',
        sortable: false,
        width: 184,
    },
    {
        title: t(`${lc}option_setting_table.option_edit_or_delete`),
        align: 'end',
        sortable: false,
        width: 130,
    },
];
export const feeGroupWorkerListTableHeader = [
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_number`),
        align: 'start',
        sortable: false,
        width: 120,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.delete`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
export const availableWorkerListTableHeader = [
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_name`),
        align: 'center',
        sortable: false,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_code`),
        align: 'center',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_number`),
        align: 'center',
        sortable: false,
        width: 120,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.group_name`),
        align: 'center',
        sortable: false,
        width: 180,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.add`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
